import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    data: null,
    error: null,
    loading: false,

  },
  getters: {




  },
  mutations: {
    SET_DATA(state, data) {
      state.data = data;
    },

    SET_ERROR(state, error) {
      state.error = error;
    }
  },
  actions: {

    // get data from api
    async getData({ commit }) {
      try {
        const response = await fetch('https://api.coindesk.com/v1/bpi/currentprice.json');
        const data = await response.json();
        commit('SET_DATA', data);
      } catch (error) {
        commit('SET_ERROR', error);
      }
    }


  },
  modules: {









  }
})
